// Services
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Libraries
const { isEqual } = require("date-fns");

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { dateMixins } from "@/app/mixins/utils/date-mixins";

// Constants
import { STATUS_CODES, SUCCESS_MSG, MATING_STATUS, WHELPING_DATE_STATUS } from "@/app/constants/status-constants";
import { BREEDER_ROUTES } from "@/app/constants/breeder-routes-constants";

// Components
const AddMatingContainer = () => import(/*webpackChunkName: "add-mating-container" */ "@/app/views/main-view/breeding-management/mating/containers/add-mating-container/add-mating-container.vue");

const GestationPeriodContainer = () =>
    import(/*webpackChunkName: "gestation-period-container" */ "@/app/views/main-view/breeding-management/gestation-period/containers/gestation-period-container/gestation-period-container.vue");

export default {
    name: "EditMatingOvulationGestationWhelpingContainer",
    components: {
        AddMatingContainer,
        GestationPeriodContainer,
    },
    directive: {},
    filters: {},
    mixins: [toastMessageMixins, dateMixins],
    props: {},
    data() {
        return {
            isAPILoading: true,
            isAPISubmitLoading: false,

            selectedDam: null,
            selectedSire: null,
            matingNotes: "",
            matingNotesHistory: [],
            matingId: null,
            damId: null,
            isDamDisabled: false,

            firstDayOfCycle: null,
            matingDate: null,
            whelpingDate: null,

            previousWhelpingDates: [],
            previousWhelpingDatesToRemove: [],

            initialValues: {
                selectedDam: null,
                selectedSire: null,
                matingNotes: "",
                firstDayOfCycle: null,
                matingDate: null,
                previousWhelpingDates: [],
                previousWhelpingDatesToRemove: [],
                typeOfBirth:null
            },

            prevRoute: "Dam/Sire List",
            prevRouteTo: BREEDER_ROUTES.DAM_SIRE_LIST,
            isAddingSuccess: false,

            littersCount: 0,
            maxLittersCount: 15,

            matingStatus: "",
            showPuppyStatusOptions: false,
            puppyStatusOptions: [MATING_STATUS.ACTIVE, MATING_STATUS.SUCCESSFUL, MATING_STATUS.UNSUCCESSFUL],
            isEditAPILoading: false,
            MATING_STATUS,
            typeOfBirth: null,
            isRedirectToLitter: false,
            isDisableAllFunction: false
        };
    },
    computed: {
        filteredPuppyStatusOptions() {
            return this.puppyStatusOptions.filter((status) => status !== this.matingStatus);
        },
    },
    watch: {},
    async created() {
        if (this.$route.query) {
            if (this.$route.query.from === "dam-details" || this.$route.query.from === "add-mating") {
                this.prevRoute = "Dam Details";
                this.prevRouteTo = `${BREEDER_ROUTES.EDIT_DAM_SIRE}?id=${this.$route.query.dam}&from=ovulation-mating`;
            } else if (this.$route.query.from === "dam-sire-list") {
                this.prevRoute = "Dam/Sire List";
                this.prevRouteTo = BREEDER_ROUTES.DAM_SIRE_LIST;
            } else if (this.$route.query.from === "mating-list") {
                this.prevRoute = "Mating List";
                this.prevRouteTo = BREEDER_ROUTES.MATING_LIST;
            } 

            // entry point is from DAM details
            if (this.$route.query.dam) {
                this.damId = this.$route.query.dam;
                this.isDamDisabled = true;
                await this.getDamAndSireMatingDetails("dam", this.damId);
            }

            // entry point is from MATING details
            if (this.$route.query.mating) {
                this.matingId = this.$route.query.mating;
                await this.getDamAndSireMatingDetails("mating", this.matingId);
            }
        }
    },
    methods: {
        async onSubmitDetails() {
            try {
                if (!this.selectedDam && !this.selectedSire) {
                    await this.$swal({
                        text: "Please select either Dam or Sire.",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });

                    return null;
                }

                if (!this.selectedDam && this.selectedSire) {
                    await this.$swal({
                        text: "Please select a Dam as well.",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });

                    return null;
                }

                this.isAPISubmitLoading = true;

                // this means the entry point was from DAM details
                if (this.isDamDisabled) {
                    /*
                    // add new mating entry if the user selected a sire
                    if (this.selectedSire && this.selectedSire.id) {
                        await this.saveMatingDetails("ADD");
                        }
                        
                        
                        // redirect to mating list after adding a new mating entry FROM Dam details
                        if (this.selectedSire && this.selectedSire.id) {
                            this.$router.push(BREEDER_ROUTES.MATING_LIST);
                            } */

                    await this.saveOvulationGestationWhelpingDates();
                }
                // update existing mating details as well as the cycle dates
                else if (this.matingId) {
                    await this.updateMatingAndCycleDates();
                }

                const identifier = this.isDamDisabled ? "dam" : "mating";
                const detailsId = this.isDamDisabled ? this.damId : this.matingId;
                await this.getDamAndSireMatingDetails(identifier, detailsId);
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPISubmitLoading = false;
            }
        },
        async updateMatingAndCycleDates() {
            const matingDetails = {
                matingId: this.matingId,
                damId: this.selectedDam ? this.selectedDam.id : null,
                sireId: this.selectedSire ? this.selectedSire.id : null,
                note: this.matingNotes,
            };

            const dateFormat = "yyyy-MM-dd";

            const cycleDetails = {
                damId: this.selectedDam.id,
                ovulationStartDate: this.firstDayOfCycle ? this.formatDateWithoutConversion(this.firstDayOfCycle, dateFormat) : null,
                matingDate: this.matingDate ? this.formatDateWithoutConversion(this.matingDate, dateFormat) : null,
                whelpingDate: this.whelpingDate ? this.formatDateWithoutConversion(this.whelpingDate, dateFormat) : null,
                typeOfBirth: this.typeOfBirth ? this.typeOfBirth: null
            };

            const detailsToSave = {
                matingDetails,
                cycleDetails,
            };

            const response = await breedingManagementService.updateMatingAndOvulationGestationWhelping(detailsToSave);

            const { SUCCESS_UPDATE_MATING_AND_CYCLE, ERROR_UPDATE_MATING_AND_CYCLE } = this.toastMessages.matingAndCycle();

            if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_MATING_AND_CYCLE);
                if(this.isRedirectToLitter) {
                    if (parseFloat(this.littersCount) === this.maxLittersCount) {
                        this.$router.push(`${BREEDER_ROUTES.LITTER_LIST}?id=${this.matingId}&from=mating-details`);
                    } else {
                        this.$router.push(`${BREEDER_ROUTES.ADD_LITTER}?id=${this.matingId}&from=mating-details`);
                    }
                }
            } else {
                this.showAPIErrorToast(ERROR_UPDATE_MATING_AND_CYCLE, response);
                this.isRedirectToLitter = false
            } 
        },
        async saveMatingDetails(actionType) {
            if (!actionType) return;

            try {
                const matingDetails = {
                    damId: this.selectedDam ? this.selectedDam.id : null,
                    sireId: this.selectedSire ? this.selectedSire.id : null,
                    note: this.matingNotes,
                };

                let response = null;

                if (actionType === "ADD") {
                    response = await breedingManagementService.addDamAndSireMatingDetails(matingDetails);

                    const { SUCCESS_ADD_MATING, ERROR_ADD_MATING } = this.toastMessages.mating();

                    if (response.status === STATUS_CODES.SUCCESS_POST) {
                        this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_MATING);
                        this.matingId = response.data;
                        this.isAddingSuccess = true;
                    } else {
                        this.showAPIErrorToast(ERROR_ADD_MATING, response);
                    }
                } else {
                    response = await breedingManagementService.updateDamAndSireMatingDetails(this.matingId, matingDetails);

                    const { SUCCESS_UPDATE_MATING, ERROR_UPDATE_MATING } = this.toastMessages.mating();

                    if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_MATING);
                        this.getDamAndSireMatingDetails(this.matingId);
                        this.isAddingSuccess = true;
                    } else {
                        this.showAPIErrorToast(ERROR_UPDATE_MATING, response);
                    }
                }

                return response.data;
            } catch (err) {
                this.isAddingSuccess = false;
                throw err;
            }
        },
        async saveOvulationGestationWhelpingDates() {
            try {
                const { SUCCESS_ADD_OVULATION_GESTATION, ERROR_ADD_OVULATION_GESTATION } = this.toastMessages.ovulationGestation();

                const dateFormat = "yyyy-MM-dd";

                // filter out whelping dates that are saved in the DB by checking if their status is "ACTIVE"
                const emptyExistingWhelpingDates = this.previousWhelpingDates.filter(({ status, date }) => {
                    return status === WHELPING_DATE_STATUS.ACTIVE && !date;
                });

                const emptyExistingWhelpingDatesIds = emptyExistingWhelpingDates.length ? emptyExistingWhelpingDates.map(({ id }) => id) : [];

                this.previousWhelpingDatesToRemove = [...this.previousWhelpingDatesToRemove, ...emptyExistingWhelpingDatesIds];

                // remove added whelping datepickers with null values
                this.previousWhelpingDates = this.previousWhelpingDates.filter(({ date }) => !!date);

                // format dates to properly save them (not index 0)
                const formattedDates = this.previousWhelpingDates.map((dateObj) => ({ ...dateObj, date: this.dateToISO(dateObj.date) }));

                const detailsToSave = {
                    damId: this.selectedDam.id,
                    ovulationStartDate: this.firstDayOfCycle ? this.formatDateWithoutConversion(this.firstDayOfCycle, dateFormat) : null,
                    matingDate: this.matingDate ? this.formatDateWithoutConversion(this.matingDate, dateFormat) : null,
                    previousWhelpingDates: formattedDates,
                    previousWhelpingDatesToRemove: this.previousWhelpingDatesToRemove,
                };
                // whelpingDate: this.whelpingDate ? this.formatDateWithoutConversion(this.whelpingDate, dateFormat) : null,

                const response = await breedingManagementService.saveOvulationAndGestation(detailsToSave);

                if (response.status === STATUS_CODES.SUCCESS_POST) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_OVULATION_GESTATION);
                    this.isAddingSuccess = true;
                } else {
                    this.showAPIErrorToast(ERROR_ADD_OVULATION_GESTATION, response);
                }
            } catch (err) {
                this.isAddingSuccess = false;
                throw err;
            }
        },
        async getDamAndSireMatingDetails(identifier, detailsId) {
            // detailsId: damId or matingId

            if (!detailsId) {
                return;
            }

            try {
                this.isAPILoading = true;
                const matingDetailsResponse = await breedingManagementService.getDamAndSireMatingDetails(identifier, detailsId);

                if (matingDetailsResponse.status === STATUS_CODES.SUCCESS) {
                    const { data: matingDetails } = matingDetailsResponse;

                    const { id: matingId, damDetails, sireDetails, matingNotesHistory, littersCount, status } = matingDetails;
                    this.matingId = matingId;
                    this.littersCount = littersCount;
                    this.matingStatus = status;

                    if (damDetails) {
                        const { breedName, dogName, birthdate } = damDetails;

                        this.selectedDam = {
                            ...damDetails,
                            birthdate: this.formatDate(birthdate),
                            customLabel: `${breedName} - ${dogName}`,
                        };

                        this.initialValues.selectedDam = this.selectedDam;
                    } else {
                        this.initialValues.selectedDam = null;
                    }

                    /*
                     * Entry point is from MATING DETAILS:
                     * Check if the entry point is from DAM details, always set selectedSire to null, since this will always be a new mating entry.
                     */
                    if (identifier !== "dam") {
                        if (sireDetails) {
                            const { breedName, dogName, birthdate } = sireDetails;

                            this.selectedSire = {
                                ...sireDetails,
                                birthdate: this.formatDate(birthdate),
                                customLabel: `${breedName} - ${dogName}`,
                            };

                            this.initialValues.selectedSire = this.selectedSire;
                        } else {
                            this.initialValues.selectedSire = null;
                            this.selectedSire = null;
                        }

                        if (matingNotesHistory && matingNotesHistory.length > 0) {
                            this.matingNotesHistory = matingNotesHistory.filter((noteObj) => noteObj.note !== "");
                            this.matingNotes = matingNotesHistory[0].note;

                            this.initialValues.matingNotes = this.matingNotes || "";
                        } else {
                            this.initialValues.matingNotes = "";
                        }
                    }
                } else {
                    const { ERROR_GET_MATING_DETAILS } = this.toastMessages.mating();
                    this.showAPIErrorToast(ERROR_GET_MATING_DETAILS, matingDetailsResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },
        handleDamSelect(data) {
            const { isInitial, selectedDam } = data;

            if (isInitial) {
                this.initialValues.selectedDam = selectedDam;
            }

            this.selectedDam = selectedDam;
        },
        handleSireSelect(data) {
            const { isInitial, selectedSire } = data;

            if (isInitial) {
                this.initialValues.selectedSire = selectedSire;
            }

            this.selectedSire = selectedSire;
        },
        handleMatingNoteChange(note) {
            this.matingNotes = note;
        },
        handleChangeFirstDayOfCycle(data) {
            const { isInitial, firstDayOfCycle } = data;

            if (isInitial) {
                this.initialValues.firstDayOfCycle = firstDayOfCycle;
            }

            this.firstDayOfCycle = firstDayOfCycle;
        },
        handleChangeMatingDate(data) {
            const { isInitial, matingDate } = data;

            if (isInitial) {
                this.initialValues.matingDate = matingDate;
            }

            this.matingDate = matingDate;
        },
        handleChangeWhelpingDate(data) {
            const { isInitial, whelpingDate, isDisableAllFunction } = data;

            if (isInitial) {
                this.initialValues.whelpingDate = whelpingDate;
            }

            this.isDisableAllFunction = isDisableAllFunction ? isDisableAllFunction : false
            this.whelpingDate = whelpingDate;
        },
        handleChangePreviousWhelpingDates(data) {
            const { isInitial, previousWhelpingDates, isDisableAllFunction } = data;

            if (isInitial) {
                this.initialValues.previousWhelpingDates = JSON.parse(JSON.stringify(previousWhelpingDates));
            }

            this.isDisableAllFunction = isDisableAllFunction ? isDisableAllFunction : false
            this.previousWhelpingDates = previousWhelpingDates;
        },
        async handleTypeOfBirthSelect(data) {
            const { isInitial, whelpingDate, typeOfBirth } = data;

            if (isInitial) {
                this.initialValues.whelpingDate = whelpingDate;
                this.initialValues.typeOfBirth = typeOfBirth;
            }
            this.whelpingDate = whelpingDate;
            this.typeOfBirth = typeOfBirth;
            this.isRedirectToLitter = true;
            await this.onSubmitDetails()
        },
        handleChangePreviousWhelpingDatesToRemove(data) {
            const { isInitial, previousWhelpingDatesToRemove } = data;

            if (isInitial) {
                this.initialValues.previousWhelpingDatesToRemove = previousWhelpingDatesToRemove;
            }

            this.previousWhelpingDatesToRemove = previousWhelpingDatesToRemove;
        },
        redirectToPrevLocation() {
            if (!this.prevRouteTo) return;

            this.$router.push(this.prevRouteTo);
        },
        redirectToAddLitter() {
            if (!this.matingId) {
                return;
            }

            if (parseFloat(this.littersCount) > 0) {
                this.$router.push(`${BREEDER_ROUTES.LITTER_LIST}?id=${this.matingId}&from=mating-details`);
            } else {
                this.$router.push(`${BREEDER_ROUTES.ADD_LITTER}?id=${this.matingId}&from=mating-details`);
            }
        },

        handleUpdateMatingStatus(status) {
            let htmlContent = `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure to update the mating status to  <strong style='color: #ff801e'>${status}</strong>?</p>`;
            this.$swal({
                title: "Update Mating Status",
                html: htmlContent,
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: true,
                showCloseButton: true,
            }).then(async (result) => {
                if (result.isDismissed) {
                    this.togglePuppyStatusOptions();
                    return;
                }

                if (!result.isDismissed && result.isConfirmed) {
                    const details = {
                        status,
                    };

                    this.isEditAPILoading = true;

                    try {
                        const response = await breedingManagementService.updateMatingStatus(this.matingId, details);
                        if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                            const { SUCCESS_UPDATE_MATING_STATUS } = this.toastMessages.mating();
                            this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_MATING_STATUS);
                            await this.getDamAndSireMatingDetails("mating", this.matingId);
                        } else {
                            this.handleMatingStatusError(response.data.errors[0]);
                        }
                    } catch (err) {
                        this.handleMatingStatusError(response.data.errors[0]);
                    } finally {
                        this.isEditAPILoading = false;
                        this.showPuppyStatusOptions = false;
                    }
                }
            });
        },
        handleMatingStatusError(err) {
            const { ERROR_UPDATE_MATING_STATUS } = this.toastMessages.mating();
            this.showCustomErrorToast(ERROR_UPDATE_MATING_STATUS, err.message);
        },
        togglePuppyStatusOptions() {
            this.showPuppyStatusOptions = !this.showPuppyStatusOptions;
        },
        statusBadge() {
            const statusMap = {
                [MATING_STATUS.ACTIVE]: "status--active",
                [MATING_STATUS.SUCCESSFUL]: "status--green",
                [MATING_STATUS.UNSUCCESSFUL]: "status--red",
            };

            return statusMap[this.matingStatus] || "status--active";
        },
    },
    beforeRouteLeave(to, from, next) {
        if(!this.isRedirectToLitter) {
           
            const isDamChanged = (this.initialValues.selectedDam ? this.initialValues.selectedDam.id : null) !== (this.selectedDam ? this.selectedDam.id : null);
            const isSireChanged = (this.initialValues.selectedSire ? this.initialValues.selectedSire.id : null) !== (this.selectedSire ? this.selectedSire.id : null);
            const isMatingNotesChanged = this.matingNotes !== this.initialValues.matingNotes;

            const isFirstDayOfCycleChanged = (this.initialValues.firstDayOfCycle ? this.initialValues.firstDayOfCycle.getTime() : null) !== (this.firstDayOfCycle ? this.firstDayOfCycle.getTime() : null);
            const isMatingDateChanged = (this.initialValues.matingDate ? this.initialValues.matingDate.getTime() : null) !== (this.matingDate ? this.matingDate.getTime() : null);
            const isWhelpingDateChanged = (this.initialValues.whelpingDate ? this.initialValues.whelpingDate.getTime() : null) !== (this.whelpingDate ? this.whelpingDate.getTime() : null);

            let isPrevWhelpingDatesChanged = false;

            if (this.previousWhelpingDates.length !== this.initialValues.previousWhelpingDates.length) {
                isPrevWhelpingDatesChanged = true;
            } else {
                if (this.previousWhelpingDates.length && this.initialValues.previousWhelpingDates.length && this.previousWhelpingDates.length === this.initialValues.previousWhelpingDates.length) {
                    isPrevWhelpingDatesChanged = this.previousWhelpingDates.some((dateObj, index) => {
                        const currentDate = new Date(dateObj.date || dateObj.whelpingDate);
                        const initialDate = new Date(this.initialValues.previousWhelpingDates[index].whelpingDate);
                        return !isEqual(currentDate, initialDate);
                    });
                }
            }

            if (
                !this.isAddingSuccess &&
                (isDamChanged || isSireChanged || isMatingNotesChanged || isFirstDayOfCycleChanged || isMatingDateChanged || isWhelpingDateChanged || isPrevWhelpingDatesChanged)
            ) {
                this.$swal({
                    imageHeight: "30px",
                    title: "You have unsaved changes!",
                    text: "Are you sure you want to leave this page?",
                    imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
                    confirmButtonColor: "#4B8BFF",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Confirm",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                }).then((result) => {
                    if (result.value) {
                        next(true);
                    } else {
                        next(false);
                    }
                });
            } else {
                next(true);
            }
        } else {
            next(true);
        }
    }
    // third party libraries
};
